import { css, type SerializedStyles } from '@emotion/react';

import { styleguideColors } from '@/Client/Styles/kaiShikiTokens';

export type OrgSettingDialogStyles = {
  message: SerializedStyles;
};

export const DEFAULT_ORG_SETTING_DIALOG_STYLES: OrgSettingDialogStyles = {
  message: css`
    label: ORG_SETTING_DIALOG_MESSAGE;
    margin: 0;
    color: ${styleguideColors.textSecondary};
  `,
};
